import React from 'react';
import Router from "./router";
import {ToastContainer} from "react-toastify";
import Security from "./components/security";

class App extends React.Component {

    constructor() {
        super();
        this.state = {
            isConnected: false,
            user: null,
        }
    }

    componentDidMount() {
        Security.getUser((user) => {
            if (!user) {
                return;
            }

            this.setState({
                user: {
                    name: user.Username,
                    role: user.RoleNames
                },
                isConnected: true
            });
        })
    }

    render() {
        return (
            <>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                />
                <Router isConnected={this.state.isConnected}/>
            </>
        );
    }
}

export default App;
